import Tether, { PLACEMENTS, BOUNDARIES } from './tether';
export { PLACEMENTS, BOUNDARIES };
export default Tether;